import React from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'
import { CardDetailFragment, CardPaymentCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { CardPaymentsDataTable } from 'modules/banking/components/CardPaymentsDataTable'
import { canViewPin } from 'modules/banking/lib/cards/canViewPin'
import { isPending } from 'modules/banking/lib/cards/isPending'
import { isRequested } from 'modules/banking/lib/cards/isRequested'

import { CardAlias } from '../_CardAlias'
import { CardControls } from '../_CardControls'
import { CardPin } from '../_CardPin'
import { Cardholder } from '../_Cardholder'
import { Limits } from '../_Limits'

const TABS = {
  CARD_PAYMENTS: 'card-payments',
  CARD_CONTROLS: 'card-controls',
  INFORMATION: 'information',
}

export const CardTabs: React.FC<{
  card: CardDetailFragment
  cardPaymentCategories: CardPaymentCategoryFragment[]
  skipCardControlsCategories: boolean
}> = ({ card, skipCardControlsCategories, cardPaymentCategories }) => {
  const [tab, setTab] = React.useState<string>(TABS.CARD_PAYMENTS)

  if (isPending(card)) {
    return null
  }

  const showCardPaymentsTable = !isPending(card) && !isRequested(card)
  const isSalaryCard = card.creationSource === 'salary'

  return (
    <Tabs tabsAlign="flexStart" onTabClicked={(tabId: string) => setTab(tabId)} currentId={tab}>
      <Tabs.Tab id={TABS.CARD_PAYMENTS} label={i18n.t('banking.cards.tabs.card_payments')}>
        <Box paddingTop="s32" gap="s24">
          {!isSalaryCard && <Limits card={card} />}
          {showCardPaymentsTable && <CardPaymentsDataTable card={card} />}
        </Box>
      </Tabs.Tab>
      {!isSalaryCard ? (
        <Tabs.Tab id={TABS.CARD_CONTROLS} label={i18n.t('banking.cards.tabs.controls2')}>
          <Box paddingTop="s32" gap="s24">
            <CardControls
              cardPaymentCategories={cardPaymentCategories}
              card={card}
              skipCategories={skipCardControlsCategories}
            />
          </Box>
        </Tabs.Tab>
      ) : (
        // TODO: should validate Tabs children as valid React elements, not only the content
        <></>
      )}
      <Tabs.Tab id={TABS.INFORMATION} label={i18n.t('banking.cards.tabs.information')}>
        <Box paddingTop="s32" gap="s24">
          {canViewPin(card) && <CardPin card={card} />}
          <CardAlias card={card} />
          <Cardholder cardholder={card.cardholder} />
        </Box>
      </Tabs.Tab>
    </Tabs>
  )
}
